import { useLanguage } from '../../../context/LanguageContext';

export default function Contact() {
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-32 bg-[#FAF8F3]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-3xl p-12 shadow-lg">
            <h2 className="text-4xl font-serif font-bold text-[#1A2B4A] mb-6">{t('contact.card1Heading')}</h2>
            <p className="text-lg text-gray-600 mb-12">
              {t('contact.card1Paragraph')}
            </p>

            <div className="space-y-8">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-[#2D7A8F]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-xl text-[#2D7A8F]"></i>
                </div>
                <div className="flex flex-col gap-1">
                  <a
                    href="tel:+37253400444"
                    className="text-xl text-[#1A2B4A] hover:text-[#2D7A8F] transition-colors font-medium tracking-wide cursor-pointer"
                  >
                    +372 53 400 444
                  </a>
                  <a
                    href="tel:+2010603700275"
                    className="text-xl text-[#1A2B4A] hover:text-[#2D7A8F] transition-colors font-medium tracking-wide cursor-pointer"
                  >
                    +20 106 03700275
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-[#2D7A8F]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xl text-[#2D7A8F]"></i>
                </div>
                <span className="text-xl text-[#1A2B4A]">info@tsconsulting.ee</span>
              </div>

              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-[#2D7A8F]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-[#2D7A8F]"></i>
                </div>
                <span className="text-xl text-[#1A2B4A]">Tallinn, Estonia</span>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 mt-12">
              <a
                href="https://wa.me/37253400444"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 px-6 py-3 bg-[#25D366] text-white rounded-full font-semibold text-base hover:bg-[#1ebe5d] transition-all cursor-pointer whitespace-nowrap shadow-md"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-xl"></i>
                </div>
                WhatsApp
              </a>
              <a
                href="viber://chat?number=%2B37253400444"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 px-6 py-3 bg-[#7360F2] text-white rounded-full font-semibold text-base hover:bg-[#5a49d6] transition-all cursor-pointer whitespace-nowrap shadow-md"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-xl"></i>
                </div>
                Viber
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}